import types from './types'

export default {
  setCategories: (categories: PlaybookCategory[]) => ({ type: types.SET_CATEGORIES, payload: categories }),
  setCategoryTypes: payload => ({ type: types.SET_CATEGORY_TYPES, payload }),
}
